import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31da644a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-blowdown" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所属镇街:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所属流域:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "排污口类型:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "排污口名称:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "入河方式:", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "整治类型:", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]

import { toRefs } from 'vue'
import { ref } from 'vue-demi'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogBlowdown',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data)?.pwkName || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data)?.szzj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data)?.szly || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(data)?.pwklx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data)?.pwkmc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(data)?.rhfs || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(data)?.zzlx || '-'), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            style: {"max-width":"500px"},
            src: _unref(data)?.pwkDataPic || '',
            alt: ""
          }, null, 8, _hoisted_25)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            style: {"max-width":"500px"},
            src: _unref(data)?.pwkPic || '',
            alt: ""
          }, null, 8, _hoisted_26)
        ])
      ])
    ])
  ]))
}
}

})